const cobaltData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133795/assets/data-reports/price-assessments/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_0ed4aa7d-1a60-48a7-aab0-20033e1b06b6_zl4f0d.png',
  priceAssessmentsBrochureFile: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Cobalt-Price-Assessment-Methodology.pdf',
    EnvKey: 'cobaltPriceAssessmentsMethodologyId',
  },
  forecastBrochureFile: {
    file_name: 'Cobalt Forecasts Brochure.pdf',
    category: 'public-documents',
    EnvKey: 'forecastBrochureCobaltFilePdfID',
  },
  esgBrochureFile: {
    file_name: 'Cobalt Sustainability Brochure.pdf',
    category: 'cobalt-esg-brochure',
    EnvKey: 'ESGBrochureCobaltFilePdfId',
  },
  banner: {
    title: `Our service includes a deep-dive on each link in the cobalt supply chain including:`,
    descriptions: [
      {
        items: [
          '<strong>Mine by Mine:</strong> Cobalt Concentrates',
          '<strong>Plant by Plant:</strong> Cobalt Chemicals',
          '<strong>Battery Focus:</strong> Demand by Cathode Chemistry with market share & intensity numbers',
          '<strong>Battery Demand:</strong> Scenarios of EV, Stationary and Portable Tech Industrial vs Battery: market-specific consumption data',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719346124/assets/market/cobalt/cobalt-1_huvz00.jpg?_i=AA',
        alt: 'Cobalt Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719346125/assets/market/cobalt/cobalt-2_buia0t.jpg?_i=AA',
        alt: 'Cobalt Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719346124/assets/market/cobalt/cobalt-3_s7urso.jpg?_i=AA',
        alt: 'Cobalt Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,f_auto,h_700,q_auto,g_auto/v1719346124/assets/market/cobalt/cobalt-4_ybq3uz.jpg?_i=AA',
      title:
        'Our full picture understanding of cobalt is most prevalent in our bottom-up cost curve analysis.',
      descriptions: [
        {
          subtitle:
            'We present a “Total Cost” number for each operating mine and development project under review which also considers: Cash/Opex, Capital Charge & Taxes & Royalties.',
          items: [
            '<strong>Time Travel:</strong> Compare Cost Curves between 2019, 2020 & 2030',
            '<strong>Plan</strong> for your future contracts, inventory or investment needs',
          ],
        },
        {
          subtitle:
            'Backed by our industry leading Price Assessment Data, our research team understand cobalt’s nuances that have a major impact on accurately forecasting prices.',
          items: [
            '<strong>Cobalt battery-grade metal</strong>',
            '<strong>Cobalt sulphate</strong>',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,f_auto,h_500,q_auto,g_auto/v1719346124/assets/market/cobalt/cobalt-5_ybpkaz.jpg?_i=AA',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Cobalt Forecast service:',
      descriptions: [
        {
          items: [
            '<strong>Online accessible</strong> downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in 3 Excel Files - Cobalt Forecast, Cobalt Price Forecast & Cobalt Total Cost Model',
            '<strong>Implement Your Ideas:</strong> Each file is fully customisable so you can input your own assumptions',
          ],
        },
      ],
    },
  },
}
export default cobaltData
